import React from 'react';

export default function ({ children }) {
  const parsedTime = parseInt(children, 10);
  const seconds = parsedTime % 60;
  const minutes = Math.floor(parsedTime / 60, 10);
  return <span>{minutes}m {seconds}s</span>;
}
